import React from 'react';
import Navbar from '../components/landing/Navbar';
import Hero from '../components/landing/Hero';
import Services from '../components/landing/Services';
import HowItWorks from '../components/landing/HowItWorks';
import Pricing from '../components/landing/Pricing';
import Contact from '../components/landing/Contact';
import Footer from '../components/landing/Footer';
import { Toaster } from 'sonner';

const LandingPage = () => {
  return (
    <div className="min-h-screen">
      <Toaster position="top-center" richColors />
      <Navbar />
      <main>
        <Hero />
        <Services />
        <HowItWorks />
        <Pricing />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
